export const showMonetateTests = {
  homepageRebuild2026: false
};
